import React from 'react';
import ThemePage from './ThemePage';

const CybersecurityPage = () => <ThemePage theme="cybersecurity" />;
const DataProtectionPage = () => <ThemePage theme="data-protection" />;
const FinancialCrimePage = () => <ThemePage theme="financial-crime" />;
const TaxCompliancePage = () => <ThemePage theme="tax-compliance" />;
const CorporateGovernancePage = () => <ThemePage theme="corporate-governance" />;
const ConsumerProtectionPage = () => <ThemePage theme="consumer-protection" />;
const EmploymentLabourPage = () => <ThemePage theme="employment-labour" />;

export {
  CybersecurityPage,
  DataProtectionPage,
  FinancialCrimePage,
  TaxCompliancePage,
  CorporateGovernancePage,
  ConsumerProtectionPage,
  EmploymentLabourPage
};
